import React from 'react';
import { Link } from 'react-router-dom';
import { DollarSign, Calendar, User } from 'lucide-react';
import KanbanBoard from './KanbanBoard';

function OpportunitiesKanban({ opportunities, stages, onStageChange, formatCurrency, canEdit = true }) {
  // Build columns from stages
  const getStageColor = (stage) => {
    if (stage.is_won) return 'success';
    if (stage.is_lost) return 'danger';
    return 'primary';
  };

  const columns = stages.map((stage) => ({
    id: stage.id,
    title: stage.name,
    color: getStageColor(stage),
    items: opportunities.filter((opp) => opp.stage_id === stage.id),
  }));

  const handleCardMove = (cardId, fromColumnId, toColumnId) => {
    onStageChange(cardId, toColumnId);
  };

  const getStageTotal = (items) => {
    return items.reduce((sum, opp) => sum + (opp.amount || opp.calculated_amount || 0), 0);
  };

  const renderColumnHeader = (column) => (
    <>
      <div className="kanban-column-title">
        <span className="kanban-stage-name">{column.title}</span>
        <span className="kanban-stage-count">{column.items.length}</span>
      </div>
      <div className="kanban-column-total">
        {formatCurrency(getStageTotal(column.items))}
      </div>
    </>
  );

  const renderCard = (opp) => (
    <>
      <Link to={`/opportunities/${opp.id}`} className="kanban-card-title">
        {opp.name}
      </Link>
      <Link to={`/accounts/${opp.account_id}`} className="kanban-card-account">
        {opp.account_name}
      </Link>
      <div className="kanban-card-details">
        <div className="kanban-card-amount">
          <DollarSign size={12} />
          {formatCurrency(opp.amount || opp.calculated_amount || 0)}
        </div>
        {opp.expected_close_date && (
          <div className="kanban-card-date">
            <Calendar size={12} />
            {new Date(opp.expected_close_date).toLocaleDateString()}
          </div>
        )}
      </div>
      {opp.owner_name && (
        <div className="kanban-card-owner">
          <User size={12} />
          {opp.owner_name}
        </div>
      )}
    </>
  );

  return (
    <KanbanBoard
      columns={columns}
      onCardMove={handleCardMove}
      renderCard={renderCard}
      renderColumnHeader={renderColumnHeader}
      getItemId={(opp) => opp.id}
      getItemColumnId={(opp) => opp.stage_id}
      canDrag={canEdit}
      emptyMessage={canEdit ? 'Drop opportunities here' : 'No opportunities'}
    />
  );
}

export default OpportunitiesKanban;
